import { useEffect, useRef } from 'react';
import { print } from 'graphql/language/printer';

export function usePolling(
  /** @type {Function} */ callback, 
  /** @type {any[]} */ stopSwitch, 
  /** @type {number} */ 
  interval = 1000
) {
  useEffect(() => {     
    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
        callback();
    }, interval);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
  }, stopSwitch);
};

export function useEndpointPolling(
  /** @type {Function} */ callback, 
  /** @type {Function} */ errorCallback, 
  /** @type {object} */ variables, 
  /** @type {import('graphql').ASTNode} */ mutationGql, 
  /** @type {string} */ accessToken, 
  /** @type {any} */ stopSwitch, 
  /** @type {number} */ interval) {
  useEffect(() => {     
    function go() {
      if (!stopSwitch)
        return;

      // save intervalId to clear the interval when the
      // component re-renders
      const intervalId = setInterval(() => {
          callback();
          try { 
            // had to use fetch instead of the useQuery hook as it can only be used at root component level
            fetch('/graphql', {
              method: 'POST',
              headers: { 
                'Content-Type': 'application/json',
                authorization: `Bearer ${accessToken}`
              },
              body: JSON.stringify({ 
                query: print(mutationGql),
                variables: variables
              }),
            })
            .then((result) => {
              if (result.status === 200) {
                return result.json();
              } else {
                throw new Error('Request failed');
              }
            })
            .then((resultBody) => {
              callback(resultBody);
            })
            .catch(() => {
              errorCallback();
            });
          }
          catch {
            errorCallback();
          }
      }, interval);

      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
    };

    go();
  }, [stopSwitch]);
};

export const useUnload = (/** @type {(this: Window, ev: BeforeUnloadEvent) => any} */ fn) => {
  const cb = useRef(fn);

  useEffect(() => {
    const onUnload = cb.current;

    console.log(onUnload)
    window.addEventListener('beforeunload', onUnload);
    return () => {
      window.removeEventListener('beforeunload', onUnload);
    };
  }, [cb]);
};